<template>
  <div class="flex flex-col gap-4 px-2 sm:px-0">
    <!-- <PageEditor
      class="h-full"
      :page-link="pageLink"
      :is-admin="authStore.isAdmin"
      :meta-title="t('head_meta.marketplace_title')"
      :meta-description="t('head_meta.marketplace_description')"
      :meta-keywords="t('head_meta.marketplace_keywords')"
    /> -->
    <div
      class="flex px-6 md:px-8 overflow-hidden rounded-xl justify-center py-10 md:py-18 bg-white relative inset-0 bg-[url('/marketplace_legal.png')] bg-no-repeat md:bg-right bg-center"
    >
      <div class="absolute inset-0 bg-black/85 bg-cover bg-center"></div>
      <div class="flex flex-col gap-4 md:gap-8 w-full text-white relative">
        <div class="text-left">
          <h1 class="text-3xl font-bold uppercase">
            {{ $t('marketplace.marketplace') }}
          </h1>
          <h3 class="text-md mt-5 max-w-[75ch] border-l-3 border-primary pl-4">
            {{ $t('marketplace.description') }}
          </h3>
        </div>
        <div class="flex flex-wrap gap-4 justify-start">
          <BaseLocaleLink to="/marketplace/offer-service">
            <BaseButton>
              {{ $t('marketplace.offer_your_service') }}
            </BaseButton>
          </BaseLocaleLink>
        </div>
      </div>
    </div>

    <div v-if="!marketplaceStore.list.loaded" class="py-10 flex justify-center">
      <BaseSpinner />
    </div>

    <MarketplaceProductList v-else :product-list="marketplaceStore.list.hits" />

    <BaseObserve
      v-if="marketplaceStore.list.loaded && !marketplaceStore.allRecordsLoaded"
      @change="nextPage"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useMarketplace } from '~/stores/marketplace'
// import { useAuth } from '~/stores/auth'

// const route = useRoute()
// const localeRoute = useLocaleRoute()
// const host = useHost()
// const authStore = useAuth()

// const pageLink = computed(() => {
//   return `${host}${localeRoute(route)?.path}`
// })
const { t } = useI18n()
const marketplaceStore = useMarketplace()

const getProductsList = async () => {
  await marketplaceStore.getProductsList()
}

async function nextPage(visible: boolean) {
  if (visible) {
    await marketplaceStore.nextPage()
  }
}

onServerPrefetch(async () => {
  await getProductsList()
})

onBeforeMount(async () => {
  !useNuxtApp().isHydrating && (await getProductsList())
})

useHeadMeta({
  title: () => t('head_meta.marketplace_title'),
  description: () => t('head_meta.marketplace_description'),
  keywords: () => t('head_meta.marketplace_keywords'),
})
</script>
